import React, { useRef, useEffect } from 'react';
import { PlusCircleIcon } from '@heroicons/react/24/solid';

// ##### AddItem Component - Renders the "Add item" input at the end of the list
export default function AddItem({ 
  newItem, 
  setNewItem, 
  onAddItem, 
  isEditMode = false 
}) {
  const textareaRef = useRef(null);

  // ##### Auto-resize textarea on content change
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  };

  // ##### Adjust height when input value changes
  useEffect(() => {
    adjustTextareaHeight();
  }, [newItem]);

  const handleInputChange = (e) => {
    setNewItem(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newItem.trim()) {
      onAddItem(newItem.trim());
      setNewItem('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Don't render if not in edit mode
  if (!isEditMode) return null;

  return (
    <li className="flex justify-between items-start bg-white py-1">
      <div className="flex items-start min-w-0 flex-1">
        {/* Drag handle placeholder for alignment */}
        <div className="mr-2 w-4 h-4 mt-2"></div>
        
        {/* No checkbox for add item - space reserved for alignment */}
        <div className="mr-2 w-4 h-4 mt-2"></div>
        
        {/* Textarea for new item */}
        <textarea
          ref={textareaRef}
          className="border-b border-blue-400 px-1 py-0.5 text-sm flex-1 outline-none resize-none overflow-hidden"
          value={newItem}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          rows={1}
          style={{ 
            minHeight: '1.5rem',
            height: 'auto',
            lineHeight: '1.5rem'
          }}
          placeholder="Add new item..."
        />
      </div>
      
      {/* Add button */}
      <PlusCircleIcon 
        className="ml-2 w-6 h-6 text-blue-700 hover:text-blue-700 cursor-pointer flex-shrink-0 mt-0.5" 
        onClick={handleSubmit}
      />
    </li>
  );
}
